import React, {useState, useEffect} from "react";
import { useLanguage } from '../../../hooks/useLanguage';
import SubBanner from "../../../components/SubBanner";
import bannerImg from '../../../assets/img/trader_banner.png';
import AceExchanges from '../../../assets/img/Logo_ACE_EXCHANGE_White.svg';
import sub_ex from "../../../assets/img/sub_ex.png";
import subLast from "../../../assets/img/sub_last.png";
import dsp_1 from "../../../assets/icon/dsp_1.svg";
import dsp_2 from "../../../assets/icon/dsp_2.svg";
import dsp_3 from "../../../assets/icon/dsp_3.svg";
import dsp_4 from "../../../assets/icon/dsp_4.svg";
import ssp_1 from "../../../assets/icon/ssp_1.svg";
import ssp_2 from "../../../assets/icon/ssp_2.svg";
import ssp_3 from "../../../assets/icon/ssp_3.svg";
import ace_ex from "../../../assets/img/ace_ex.svg";
import logo_dsp_1 from "../../../assets/img/logo_dsp_1.png";
import logo_dsp_2 from "../../../assets/img/logo_dsp_2.png";
import logo_dsp_3 from "../../../assets/img/logo_dsp_3.png";
import logo_dsp_4 from "../../../assets/img/logo_dsp_4.png";
import logo_dsp_5 from "../../../assets/img/logo_dsp_5.png";
import logo_dsp_6 from "../../../assets/img/logo_dsp_6.png";
import logo_dsp_7 from "../../../assets/img/logo_dsp_7.png";
import logo_dsp_8 from "../../../assets/img/logo_dsp_8.png";
import logo_dsp_9 from "../../../assets/img/logo_dsp_9.png";
import logo_dsp_10 from "../../../assets/img/logo_dsp_10.png";
import logo_dsp_11 from "../../../assets/img/logo_dsp_11.png";
import logo_dsp_12 from "../../../assets/img/logo_dsp_12.png";
import logo_dsp_13 from "../../../assets/img/logo_dsp_13.png";
import logo_dsp_14 from "../../../assets/img/logo_dsp_14.png";
import logo_dsp_15 from "../../../assets/img/logo_dsp_15.png";
import logo_dsp_16 from "../../../assets/img/logo_dsp_16.png";
import logo_ssp_1 from "../../../assets/img/logo_ssp_1.png";
import logo_ssp_2 from "../../../assets/img/logo_ssp_2.png";
import logo_ssp_3 from "../../../assets/img/logo_ssp_3.png";
import logo_ssp_4 from "../../../assets/img/logo_ssp_4.png";
import logo_ssp_5 from "../../../assets/img/logo_ssp_5.png";
import logo_ssp_6 from "../../../assets/img/logo_ssp_6.png";
import logo_ssp_7 from "../../../assets/img/logo_ssp_7.png";
import logo_ssp_8 from "../../../assets/img/logo_ssp_8.png";
import logo_ssp_9 from "../../../assets/img/logo_ssp_9.png";
import logo_ssp_10 from "../../../assets/img/logo_ssp_10.png";
import logo_ssp_11 from "../../../assets/img/logo_ssp_11.png";
import logo_ssp_12 from "../../../assets/img/logo_ssp_12.png";
import logo_ssp_13 from "../../../assets/img/logo_ssp_13.png";
import logo_ssp_14 from "../../../assets/img/logo_ssp_14.png";
import logo_ssp_15 from "../../../assets/img/logo_ssp_15.png";
import logo_ssp_16 from "../../../assets/img/logo_ssp_16.png";
import { ATTACHMENT_URL } from "../../../utils/urls";
import instance from "../../../services/services";
import ex_map from "../../../assets/img/map.png";

function Exchange(){
  const { t } = useLanguage();
  
   // 0: ACE Trader, 1: ACE eXchange, 2: ADLIB
  const [activeTab, setActiveTab] = useState(1);
  const [exchangeData, setExchangeData] = useState([]);
  const tabList = [
    { label: "ACE Trader", url: "/solutions/aceTrader" },
    { label: "ACE eXchange", url: "/solutions/aceExchange" },
    { label: "ACE ADLIB", url: "/solutions/adlib" },
  ];

  // 추천유형 섹션
  const aceExchageDsp = t('sub_section_2.aceExchage_dsp', []);
  const aceExchageSsp = t('sub_section_2.aceExchage_ssp', []);

  const dspImages = [dsp_1, dsp_2, dsp_3, dsp_4];
  const sspImages = [ssp_1, ssp_2, ssp_3];
  
  const dspBox = aceExchageDsp.map((item, idx) => ({
    ...item,
    img: dspImages[idx]
  }));
  
  const sspBox = aceExchageSsp.map((item, idx) => ({
    ...item,
    img: sspImages[idx]
  }));

  // ace 파트너 로고
  const dspLogo = [
    {img:logo_dsp_1},
    {img:logo_dsp_2},
    {img:logo_dsp_3},
    {img:logo_dsp_4},
    {img:logo_dsp_5},
    {img:logo_dsp_6},
    {img:logo_dsp_7},
    {img:logo_dsp_8},
    {img:logo_dsp_9},
    {img:logo_dsp_10},
    {img:logo_dsp_11},
    {img:logo_dsp_12},
    {img:logo_dsp_13},
    {img:logo_dsp_14},
    {img:logo_dsp_15},
    {img:logo_dsp_16},
  ]
  const sspLogo = [
    {img:logo_ssp_1},
    {img:logo_ssp_2},
    {img:logo_ssp_3},
    {img:logo_ssp_4},
    {img:logo_ssp_5},
    {img:logo_ssp_6},
    {img:logo_ssp_7},
    {img:logo_ssp_8},
    {img:logo_ssp_9},
    {img:logo_ssp_10},
    {img:logo_ssp_11},
    {img:logo_ssp_12},
    {img:logo_ssp_13},
    {img:logo_ssp_14},
    {img:logo_ssp_15},
    {img:logo_ssp_16},
  ]

  useEffect(()=> {
    const fetchAttachment = async () => {
      try {
        const response = await instance.post(ATTACHMENT_URL)
        setExchangeData(response.data.data.exchange);
      }
      catch(error) {
        console.error('첨부파일 데이터 가져오기 실패:', error);
      }
    }
    fetchAttachment();
  }, []);


  return(
    <div className="solutions">
    {/* 배너 */}
      <SubBanner
        bgImg={bannerImg}
        logoImg={AceExchanges}
        description={
          <span
            dangerouslySetInnerHTML={{
              __html: t('aceExchage.descriptionHtml')
            }}
          />
        }
        buttons={[
          { label: t('aceExchage.btn_1'), url: `https://admin.nhnace.com${exchangeData?.file_path}` },
          { label: t('aceExchage.btn_2'), url: "http://pubcenter.toast.com/" }
        ]}
        tabs={tabList.map((tab,idx) => ({
          label : tab.label,
          url : tab.url,
          active: activeTab === idx,
          onClick: () => setActiveTab(idx),
        }))}
        location={[
          { label: "Solution", url: "/solution" },
          { label: "ACE eXchange", url: "/solution/aceExchage", active: true }
        ]}
      />

      <section className="sub_section mb-[120px] md:mb-[160px] mt-[160px]  md:mt-[220px] mx-auto">
        <div className="sub_txt_box">
          <figure><img src={ace_ex} alt="ace_ex"/></figure>
          <span className="mt-[8px]">{t('sub_section_1.aceExchage_desc')}</span>
          <p dangerouslySetInnerHTML={{ __html: t('sub_section_1.aceExchage_con') }} />
        </div>
        <div>
          <figure className="m-auto">
            <img src={sub_ex} alt="sub_ex" loading="lazy"/>
          </figure>
        </div>
      </section>

      <section className="mx-auto sub_page_bg_ex" >
        <div className="sub_txt_box">
          <h3 className="f_40 text-white">{t('sub_section_2.aceExchage_title')}</h3>
          <span className="mt-[10px]">{t('sub_section_2.aceExchage_desc')}</span>
        </div>

        <div className="partner_container mx-auto mt-[80px] lg:mt-[120px]">
          {/* dspBox */}
          <div className="dsp_box">
            <div className="tit">
              <b>for DSP Partners</b>
            </div>
            <ul>
              <div className="dsp_con">
                {dspBox.map((dsp, idx) => (
                  <li key={idx}>
                    <div className="dsp_left">
                      <img src={dsp.img} alt={`dsp_${idx+1}`}/>
                    </div>
                    <div className="dsp_right">
                      <h4>{dsp.title}</h4>
                      <p>{dsp.txt}</p>
                    </div>
                  </li>
                ))}
              </div>
            </ul>
          </div>

          {/* sspBox */}
          <div className="dsp_box ssp_box">
            <div className="tit">
              <b>for SSP Partners</b>
            </div>
            <ul>
              <div className="dsp_con">
                {sspBox.map((ssp, idx) => (
                  <li key={idx}>
                    <div className="dsp_left">
                      <img src={ssp.img} alt={`ssp_${idx+1}`}/>
                    </div>
                    <div className="dsp_right">
                      <h4>{ssp.title}</h4>
                      <p>{ssp.txt}</p>
                    </div>
                  </li>
                ))}
              </div>
            </ul>
          </div>
        </div>
      </section>

      <section className="py-[120px] mx-auto" >
        <div className="sub_txt_box px-[20px]">
          <h3 className="f_40">Global Service</h3>
          <span className="mt-[10px]" dangerouslySetInnerHTML={{ __html: t('add.aceExchage_desc') }} />
        </div>

        <div className="partner_container mx-auto mt-[80px] lg:mt-[120px]">
            <figure className="m-auto">
              <img src={ex_map} alt="ex_map" loading="lazy"/>
            </figure>
        </div>
      </section>

      <section className="sub_section mb-[120px] mx-auto">
        <div className="sub_txt_box">
          <h3 className="f_40">{t('sub_section_3.aceExchage_title')}</h3>
          <span className="mt-[10px]">{t('sub_section_3.aceExchage_desc')}</span>
        </div>
        <div className="logo_map_container mt-[50px] md:mt-[120px] mx-auto mb-auto">
          <p className="red_btn_txt">our DSP Partners</p>
          <ul className="logo_map">
            {dspLogo.map((logo,idx)=>(
              <li key={idx}>
                <img src={logo.img} alt="logo"/>
              </li>
            ))}
          </ul>
        </div>
        <div className="logo_map_container mt-[50px] md:mt-[120px] mx-auto mb-auto">
          <p className="red_btn_txt">our SSP Partners</p>
          <ul className="logo_map">
            {sspLogo.map((logo,idx)=>(
              <li key={idx}>
                <img src={logo.img} alt="logo"/>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="sub_last">
        <div className="sub_last_inner">
          <div className="sub_left">
            <h3 className="f_40 text-left" dangerouslySetInnerHTML={{ __html: t('common_section.common_title') }} />
            <div className="banner_btn">
              <a
                href={`https://admin.nhnace.com${exchangeData?.file_path}`}
                onClick={(e) => {
                  e.preventDefault();
                  window.open(`https://admin.nhnace.com${exchangeData?.file_path}`, '_blank');
                }}
                style={{ cursor: 'pointer' }}
              >
                {t('aceExchage.btn_1')}
              </a>
              <a
                href="http://pubcenter.toast.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('aceExchage.btn_2')}
              </a>
            </div>
          </div>
          
          <div className="sub_right">
            <img src={subLast} alt="subLast" loading="lazy"/>
          </div>
        </div>
      </section>
      




    </div>
  )
};

export default Exchange;
